"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compressorjs_1 = __importDefault(require("compressorjs"));
const react_device_detect_1 = require("react-device-detect");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const webview_app_1 = require("@/webview_app");
// ! webp issue
// Compressor.js 는 canvas.toBlob API 를 사용하는데,
// 사파리 브라우저, iOS 브라우저(iOS사파리, iOS크롬, etc.)에서는 webp + canvas.toBlob 이 아직은 안됨
// ? https://caniuse.com/mdn-api_htmlcanvaselement_toblob_type_parameter_webp
// ! webp의 maximum size: 16383px x 16383px
// ? https://developers.google.com/speed/webp/faq?hl=ko#what_is_the_maximum_size_a_webp_image_can_be
function default_1({ imageFile, maxWidth, maxHeight = 16000, quality, onCompressSuccess, onCompressError = () => { }, isCheckingSizeElsewhere, }) {
    const isSafariEngine = react_device_detect_1.isSafari || react_device_detect_1.isIOS;
    const mimeType = isSafariEngine ? 'image/jpg' : 'image/webp';
    const supportTypeRegExp = new RegExp(/image\/(jpeg|jpg|png|gif|bmp|webp)/);
    if (!supportTypeRegExp.test(imageFile.type)) {
        alert(`${i18next_1.default.t('이미지 파일을 올려주세요')}(jpg, png)`);
        onCompressError();
    }
    else {
        new compressorjs_1.default(imageFile, {
            maxWidth,
            maxHeight,
            quality,
            mimeType,
            success(compressedBlob) {
                if (!isCheckingSizeElsewhere && compressedBlob.size > 5000000) {
                    (0, functions_1.showToastMessage)({ message: `${i18next_1.default.t('이미지 크기는 5MB이하가 적당해요')}:)` });
                    onCompressError();
                }
                else {
                    const convertedExtension = isSafariEngine ? 'jpg' : 'webp';
                    const compressedFile = new File([compressedBlob], `${imageFile.name.split('.')[0].slice(0, 20)}.${isSafariEngine ? 'jpg' : 'webp'}`, { type: mimeType, lastModified: new Date().getTime() });
                    onCompressSuccess(compressedFile, convertedExtension);
                }
            },
            error(err) {
                alert((0, errors_1.commonErrorMsg)() + err.message);
                if (window.isNativeApp) {
                    (0, webview_app_1.postMessageToWVA)(`CLIPBOARD::${JSON.stringify(err.stack)}`);
                    alert('클립보드에 에러내용이 복사 되었어요. 붙여넣기로 폰디에게 보내주시면 도와드릴게요!');
                }
                onCompressError();
            },
        });
    }
}
exports.default = default_1;
